import React, { Component, Fragment } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Form, 
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import moment from 'moment';
import { Request } from "common-import/helpers";
const $ = require('jquery');

class UploadImage extends Component {

  state = {
    url: '',
    forms: [
      { url: '' },
      { url: '' },
    ],
  }


  async componentDidMount() {
  }

  addForm = () => {
    const { forms } = this.state;
    forms.push({ url: '' });
    this.setState({ forms });
  }

  clearForm = (index) => {
    const { forms } = this.state;
    forms[index].url = '';
    this.setState({ forms });
  }

  uploadInput = async (e, index) => {
    const file = e.target.files[0];
    const uploadedUrl = await Request.upload(file);
    let { forms } = this.state;
    forms[index].url = uploadedUrl;
    this.setState({ forms });
  }

  openUpload = index => {
    $('#upload-'+index).trigger('click');
  }

  copyToClipboard = (index) => {
    let input = document.getElementById("file-"+index);
    input.select();
    document.execCommand("copy");
}

  render() {
    const { forms } = this.state;
    return (
      <div className="animated fadeIn">
        {
          forms.map((form, index) => (
            <Form key={"form"+index}>
              <FormGroup row>
                <Col md="12">
                  <input type="file" id={"upload-"+index} name={"upload-"+index} style={{ display: "none" }} onChange={(e) => this.uploadInput(e, index)} />
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <Button type="button" color="primary" onClick={() => this.openUpload(index)}><i className="fa fa-upload"></i> Upload</Button>
                        {
                          form.url !== '' && 
                          <Fragment>
                            <Button type="button" color="warning" onClick={() => this.copyToClipboard(index)}><i className="fa fa-clipboard"></i> Copy</Button>
                            <Button type="button" color="danger" onClick={() => this.clearForm(index)}><i className="fa fa-times"></i> Clear</Button>
                          </Fragment>
                        }
                    </InputGroupAddon>
                    <Input id={"file-"+index} type="text" placeholder="Kết quả url.." value={form.url} readOnly />
                  </InputGroup>
                </Col>
              </FormGroup>
            </Form>
          ))
        }
        <div>
          <Button type="button" color="danger" onClick={this.addForm}><i className="fa fa-plus"></i> Thêm Form</Button>
        </div>
      </div>
    );
  }
}

export default UploadImage;


// WEBPACK FOOTER //
// ./src/views/Dashboard/UploadImage.js